import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig() ?? {};

// We should not use env variables directly, depending on runtime it might come from process or window
const getEnv = envKey => {
  return publicRuntimeConfig?.[envKey];
};

export default getEnv;
